import LanguageMenu from "./LanguageMenu";

export default LanguageMenu;
